__webpack_require__.tu = (url) => (__webpack_require__.tt().createScriptURL(url))